// src/icons.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUser, faHandshake, faLightbulb, faBriefcase, faShieldAlt, faBars, faCalendarAlt, faEnvelope, faHeadset, faCoins, faCode, faShapes, faCogs, faCheckSquare } from '@fortawesome/free-solid-svg-icons';

library.add(faUser, faHandshake, faLightbulb, faBriefcase, faShieldAlt, faBars, faCalendarAlt, faEnvelope, faHeadset, faCoins, faCode, faShapes, faCogs, faCheckSquare);
